import React from 'react';
import classNames from 'classnames';
import 'lazysizes';

import styles from '../image.module.scss';

interface LazyImageProps {
    alt: string;
    src: string;
    srcSet: string;
}

const LazyImage = ({ alt, src, srcSet }: LazyImageProps) => (
    <img
        alt={alt}
        data-src={src}
        data-srcset={srcSet}
        width={130}
        height={108}
        className={classNames(styles.image, 'lazyload')}
    />
);

export default LazyImage;
